var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRebuttalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E869272B-3ECB-4B1E-8A94-ADBAB4FFA19B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-742.000000, -464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(742.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0 C22.6568542,-3.04359188e-16 24,1.34314575 24,3 L24,14 C24,15.6568542 22.6568542,17 21,17 L16.5605152,17.0009262 C16.4750195,17.1486586 16.3690613,17.2877929 16.2426407,17.4142136 L13.4142136,20.2426407 C12.633165,21.0236893 11.366835,21.0236893 10.5857864,20.2426407 L7.75735931,17.4142136 C7.63093869,17.2877929 7.52498052,17.1486586 7.43948481,17.0009262 L3,17 C1.34314575,17 2.02906125e-16,15.6568542 0,14 L0,3 C-2.02906125e-16,1.34314575 1.34314575,1.19253761e-15 3,0 L21,0 Z",
    id: "Combined-Shape",
    fill: "#FFB647"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    transform: "translate(11.000000, 4.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0.949210133,
    x2: 1,
    y2: 4.94921013,
    id: "Path-8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB647",
    cx: 1,
    cy: 7.94921013,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebuttalIcon);
export default __webpack_public_path__ + "static/media/rebuttal-icon.54197d22159f6a1108f3072be374314a.svg";
export { ForwardRef as ReactComponent };